import exportPdf from './export-pdf'
import preview from './preview'

export const EXPORT_PDF = 'EXPORT_PDF'
export const PREVIEW = 'PREVIEW'

export default {
  [EXPORT_PDF]: exportPdf,
  [PREVIEW]: preview
}